import styled, { css } from 'styled-components';
import {
  ConfiguratorTimelineLock,
  ServicesIconsStripeLogo
} from '@elfsight/icons';
import { Icon } from '@elfsight/lib-icon';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import type { TypographyToken } from '@elfsight/widget-ui';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { CLASS_COMPONENT, STYLE_DEFAULTS } from '../../common';

const STRIPE_BLURPLE = '#645cffff';

export function SecurePaymentCaption({
  color,
  translatedTextLabel,
  textToken = 'text15'
}: {
  translatedTextLabel: string;
  color?: string;
  textToken?: TypographyToken;
}) {
  const halfTransparentColor = getColorWithAlpha(
    color || STYLE_DEFAULTS.textColor,
    0.5
  );

  return (
    <Typography
      textToken={textToken}
      color={halfTransparentColor}
      className={createReadableClass({
        component: CLASS_COMPONENT,
        element: 'secure-payment-caption'
      })}
    >
      <InlineLockIcon
        component={ConfiguratorTimelineLock}
        size={16}
        fill={halfTransparentColor}
      />
      {translatedTextLabel}
      <InlineStripeLogo height={16} fill={STRIPE_BLURPLE} />
    </Typography>
  );
}

const inlineIconMixin = css`
  display: inline-block;
  vertical-align: text-bottom;
`;

const InlineLockIcon = styled(Icon)`
  ${inlineIconMixin}
  margin-right: 4px;
`;

const InlineStripeLogo = styled(ServicesIconsStripeLogo)`
  ${inlineIconMixin}
  margin-left: 4px;
`;
